var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{
    name: 'products-CategoryPage',
    query: { category: '002d8494-ce6f-ee11-810a-00155d97e129' } }}},[_c('v-img',{staticClass:"w-100",attrs:{"src":require("../assets/banner1.svg"),"srcset":"../assets/banner1-mobile.svg 480w, ../assets/banner1.svg 1024w","sizes":"(max-width: 480px) 480px, 1024px","stretch":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }